import React, { useContext, useEffect, useState } from 'react'
import { Button, Col, Row } from 'reactstrap'
import QuickOrderItemCardLandscape from '../QuickOrder/QuickOrderItemCardLandscape'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { ShoppingContext } from '../../shared/ShoppingContext'
import LoginLoading from '../Spinner/Spinner'
import '../EnhancedHome/EnhancedHome.scss'
import QuickOrderItemCard from '../QuickOrder/QuickOrderItemCard'
import ProductHOC from '../Reusable/ProductHOC'
import TransactionHOC from '../Reusable/TransactionHOC'
import { setAlternativeItems, setCorrelatedItems } from '../../actions'

function ProductDetailsAfterAddPage(props) {
  // const [ loadingRelatedProducts, setLoadingRelatedItems ] = useState(true)
  // const [ relatedProducts, setRelatedItems ] = useState([])
  const [chosenItemList, setChosenItemList] = useState([])
  const { userSpecificItems, userSpecificItemsLoading } = useContext(ShoppingContext)
  const {
    isAuthenticated,
    item,
    setShowAfterAddPage,
    logClickEvent,
    loadingRelatedProducts,
    relatedProducts,
    enhancedRelatedProducts,
  } = props

  const { industrySuggestions, purchaseAgain, recentUserSearchProducts, timeToReorder } =
    userSpecificItems
  const listsInOrder = [
    relatedProducts,
    timeToReorder,
    purchaseAgain,
    industrySuggestions,
    recentUserSearchProducts,
  ]

  const algoliaRecommendsItems = enhancedRelatedProducts.length
    ? Object.values(enhancedRelatedProducts).flatMap(items => items)
    : []

  // useEffect(() => {
  //   window.scrollTo(0, 0)
  //   const getCorrelatedItems = async () => {
  //     setLoadingRelatedItems(true)
  //     const correlatedItems = await props.setCorrelatedItems(item.id)
  //     setRelatedItems(correlatedItems)
  //     setLoadingRelatedItems(false)
  //   }

  //   getCorrelatedItems()
  // },[])

  useEffect(() => {
    const getChosenItemList = async () => {
      for (let i = 0; i < listsInOrder.length; i++) {
        if (listsInOrder[i]?.length > 0) {
          setChosenItemList(listsInOrder[i])
          break // Break immediately after setting, as the next lines will run against outdated state
        }
      }
    }

    if (!loadingRelatedProducts) {
      getChosenItemList()
    }
  }, [
    loadingRelatedProducts,
    relatedProducts,
    timeToReorder,
    purchaseAgain,
    industrySuggestions,
    recentUserSearchProducts,
  ])

  return (
    <div>
      <Row
        style={{
          backgroundColor: 'white',
          margin: '12px auto',
          borderRadius: '7px',
          justifyContent: 'space-between',
          paddingTop: '12px',
        }}
      >
        <Col
          xs="12"
          sm="7"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            gap: '20px',
            maxWidth: '800px',
          }}
        >
          <QuickOrderItemCardLandscape
            key={item.id}
            product={item}
            enhancedOrdering={true}
            isAuthenticated={isAuthenticated}
            sectionTitle={'ProductDetailsAfterAddPage_AddMore'}
            setShowAfterAddPage={setShowAfterAddPage}
            // showQuantityCounter={true}
          />
        </Col>
        <Col
          xs="12"
          sm="4"
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '20px',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '20px',
            }}
          >
            <Link to="/cart" className="pdpAfterAdd__cart-view">
              <div
                onClick={() =>
                  logClickEvent({ eventType: 'ProductDetailsAfterAddPage_View_Cart_Click' })
                }
              >
                View Cart
              </div>
            </Link>
            <Link to="/checkout" className="pdpAfterAdd__cart-checkout">
              <div
                onClick={() =>
                  logClickEvent({ eventType: 'ProductDetailsAfterAddPage_Checkout_Click' })
                }
              >
                Proceed To Checkout
              </div>
            </Link>
          </div>
        </Col>
      </Row>

      <>
        <div className="item-carousel">
          {!chosenItemList.length ? (
            <div style={{ marginBottom: '111px', marginTop: '-130px' }}>
              <LoginLoading />
            </div>
          ) : (
            <div style={{ padding: '22px' }}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '20px',
                  flexWrap: 'wrap',
                }}
              >
                {/* <EnhancedHomepageSlider
                        items={items}
                        sectionTitle="Checkout Carousel"
                        enhancedOrdering={true}
                        isAuthenticated={isAuthenticated}
                      /> */}
                {algoliaRecommendsItems?.concat(chosenItemList)?.map(item => (
                  <div key={item.id}>
                    <QuickOrderItemCard
                      key={item.id}
                      product={item.correlatedItem || item}
                      enhancedOrdering={!item.latestPurchase}
                      isAuthenticated={isAuthenticated}
                      sectionTitle={'PDP_AfterAdd_'}
                      showQuantityCounter={true}
                      isCheckoutInterPage={true}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
    product: state.shopping.product,
    quantitySelected: state.shopping.quantitySelected,
    sellableCSLs: state.shopping.sellableCSLs,
    uom: state.shopping.uom,
    alternativeItems: state.shopping.alternativeItems,
    correlatedItems: state.shopping.correlatedItems,
    allocationMax: state.shopping.allocationMax,
    category: state.shopping.product.data.category?.parent,
    subcategory: state.shopping.product.data.category,
    retrievingAllocation: state.loader.retrievingAllocation,
    accountLoading: state.loader.accountLoading,
  }
}

export default withRouter(
  connect(mapStateToProps, { setCorrelatedItems, setAlternativeItems })(
    ProductHOC(TransactionHOC(ProductDetailsAfterAddPage)),
  ),
)
